import api from "./api";

export async function listCommunicationThreads(params = {}) {
  const response = await api.get("/communications/threads", { params });
  return Array.isArray(response?.data?.items) ? response.data.items : [];
}

export async function getCommunicationThread(id, params = {}) {
  const response = await api.get(`/communications/threads/${id}`, { params });
  return {
    thread: response?.data?.thread || null,
    messages: Array.isArray(response?.data?.messages) ? response.data.messages : [],
    meta: response?.data?.meta || {},
  };
}

export async function createCommunicationThread(payload) {
  const response = await api.post("/communications/threads", payload);
  return {
    thread: response?.data?.thread || null,
    messages: Array.isArray(response?.data?.messages) ? response.data.messages : [],
  };
}

export async function createCommunicationMessage(threadId, payload) {
  const response = await api.post(`/communications/threads/${threadId}/messages`, payload);
  return response?.data?.message || null;
}

export async function linkCommunicationThreadToProject(threadId, projectId) {
  const response = await api.post(`/communications/threads/${threadId}/link-project`, { projectId });
  return response?.data?.thread || null;
}

export async function updateCommunicationThreadStatus(threadId, status) {
  const response = await api.patch(`/communications/threads/${threadId}/status`, { status });
  return response?.data?.thread || null;
}

export async function markCommunicationThreadRead(threadId, params = {}) {
  const response = await api.post(`/communications/threads/${threadId}/mark-read`, {}, { params });
  return response?.data?.thread || null;
}

export async function updateCommunicationThreadPortalVisibility(threadId, customerPortalVisible, params = {}) {
  const response = await api.patch(
    `/communications/threads/${threadId}/portal-visibility`,
    { customerPortalVisible },
    { params }
  );
  return response?.data?.thread || null;
}

export async function updateCommunicationThreadReplyPolicy(threadId, portalAllowReply, params = {}) {
  const response = await api.patch(
    `/communications/threads/${threadId}/reply-policy`,
    { portalAllowReply },
    { params }
  );
  return response?.data?.thread || null;
}

export async function sendCommunicationThreadPortalNotification(threadId, params = {}) {
  const response = await api.post(
    `/communications/threads/${threadId}/send-portal-notification`,
    {},
    { params }
  );
  return {
    thread: response?.data?.thread || null,
    delivery: response?.data?.delivery || null,
    recipientCount: Number(response?.data?.recipientCount || 0),
  };
}
